import { Button } from "@mui/material";
import { ReactNode } from "react";

export const CustomTextButton = ({
  onClick,
  children,
}: {
  onClick: () => void;
  children: ReactNode;
}) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        textDecoration: "underline",
        whiteSpace: "nowrap",
        background: "none",
        color: "#1C3C6C",
      }}
    >
      {children}
    </Button>
  );
};
